<template>
	<div class="notification">
		<h3 class="notification-head">
			<var class="notification-title">{{title}}</var>
			<span>
				Vigente desde {{ starts_on | dateLatin }} hasta {{ finish_on  | dateLatin }} 
			</span>
		</h3>
		<p class="notification-subtitle">{{subtitle}}</p>
		<p class="notification-body" v-html="content"></p>
	</div>
</template>

<script>

export default {
	props: [
		'title',
		'starts_on',
		'finish_on',
		'subtitle',
		'content',
	],
}
</script>

<style>
    .notification {
        padding: 20px !important;
    }
    .notification .notification-head {
		font-family: "Raleway",sans-serif;
		text-transform: uppercase;
		font-size: 1.4rem;
		font-weight: 500;
		color: #4a4a4a;
		display: flex;
		justify-content: space-between;
		align-items: baseline;;
    }
    .notification .notification-head span {
		color: #999;
		font-size: 60%;
		text-transform: none;
		text-align: right;
    }

	.notification .notification-subtitle {
		padding-top: 10px;	
		font-size: 1em;
	}
	.notification .notification-subtitle{
		text-transform: uppercase;
	}
	.notification .notification-body {
		color: #999;
	}

</style>
